import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/fall-cleanup-highland-ut")({
  beforeLoad: () => {
    throw redirect({
      href: "/services/fall-cleanup",
      statusCode: 301,
    });
  },
});
